import styles from './h1.module.css'

type Props = {
  children: React.ReactNode,
  level?: number,
  // suppressMargin?: boolean,
}

type ReactWrapFn = (_: React.ReactNode) => React.ReactNode
type ElementForLevel = { [key: number]: ReactWrapFn }
// type TagForLevel = { [key: number]: React.ReactNode }

// const tagForLevel: TagForLevel = {
//   1: <h1 />,
//   2: <h2 />,
//   3: <h3 />,
//   4: <h4 />,
//   5: <h5 />,
//   6: <h6 />,
// }

const getElementForLevel = {
  1: (children: React.ReactNode) =>
    <h1 className={styles.heading1}>{ children }</h1>,
  2: (children: React.ReactNode) =>
    <h2 className={styles.heading2}>{ children }</h2>,
  3: (children: React.ReactNode) =>
    <h3 className={styles.heading3}>{ children }</h3>,
  4: (children: React.ReactNode) =>
    <h4 className={styles.heading4}>{ children }</h4>,
  5: (children: React.ReactNode) =>
    <h5 className={styles.heading5}>{ children }</h5>,
  6: (children: React.ReactNode) =>
    <h6 className={styles.heading6}>{ children }</h6>,
} as ElementForLevel

const Heading = ({ children, level = 1 }: Props) => {
  // const Tag = tagForLevel?.[level]
  return getElementForLevel[level](children) as JSX.Element
}

export default Heading
